import { CometUserAuthenticationWebHandler_getUser_queryOptions } from '@zg-rentals/ts-capps-client-react-query';
import { defineAuthProvider } from '@zg-rentals/auth-react';
import { isAuthorized } from '@zg-rentals/auth-comet';

export const Auth = defineAuthProvider({
  queryOptions: () =>
    CometUserAuthenticationWebHandler_getUser_queryOptions({
      pageWithSensitiveInformation: true,
    }),

  isAuthorized: isAuthorized({
    mapUser: (user) => user,
    requireStrongAuthentication: true,
  }),
});

export const { useAuth } = Auth;
